import * as React from "react"
import {Divider, Grid, Typography} from "@mui/material";
import {ButtonLoadingSeeker, IconSeeker} from "@ui-seeker/core";

import LoginFormBlock from "./BlockForm";


export default function LoginForm() {

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<Typography variant="h4" sx={{ mb: 0 }}>
				Welcome Back
			</Typography>
		</Grid>

		<Grid item xs={12} sx={{ mb: 3 }}>
			<Typography variant="subtitle">
				Enter your email and password
			</Typography>
		</Grid>

		<Grid item xs={12}>
			<LoginFormBlock />
		</Grid>

		<Grid item xs={12} sx={{ my: 3 }}>
			<Divider>Or</Divider>
		</Grid>

		<Grid item xs={12}>
			<ButtonLoadingSeeker
				variant="outlined"
				color="error"
				startIcon={<IconSeeker icon="google" iconWeight="brands" />}
				sx={{ width: 1 }}
			>
				Sign in with Google
			</ButtonLoadingSeeker>
		</Grid>
	</Grid>
}